import { constants } from "@thecb/components";

const {
  CORNFLOWER_BLUE,
  LINK_WATER,
  ROYAL_BLUE_VIVID,
  MANATEE_GREY,
  GHOST_GREY,
  TRANSPARENT,
  BRIGHT_GREY
} = constants.colors;

const disabledBackgroundColor = TRANSPARENT;
const disabledBorderColor = GHOST_GREY;
const disabledColor = MANATEE_GREY;
const activeBackgroundColor = CORNFLOWER_BLUE;
const backgroundColor = LINK_WATER;
const borderColor = MANATEE_GREY;
const color = ROYAL_BLUE_VIVID;
const textColor = BRIGHT_GREY;

export const fallbackValues = {
  disabledBackgroundColor,
  disabledBorderColor,
  disabledColor,
  activeBackgroundColor,
  backgroundColor,
  borderColor,
  color,
  textColor
};
